export default __webpack_public_path__ + "static/media/bot.3ad69c61.png";